module.exports = __webpack_public_path__ + "img/arrowback.67234088.svg";